<template>
    <div class="field">
        <label class="label">Art</label>
        <div class="control">
            <div class="select-container">
                <i :class="{ 'fa fa-spinner fa-spin': this.isLoading }" />
                <input
                    v-model="localName"
                    @focusout="onSpeciesComplete"
                    list="speciesSuggestions"
                    class="input"
                    type="text"
                    spellcheck="false"
                    autocomplete="off"
                    required
                    placeholder="Skriv art..."
                />
                <datalist id="speciesSuggestions">
                    <option v-for="s in speciesList" :value="s.name" :key="s.id">{{ s.name }}</option>
                </datalist>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    props: { species: Object },
    data() {
        return {
            localSpecies: this.species,
            localName: null,
        };
    },
    watch: {
        species(species) {
            this.localSpecies = species;
            this.localName = species.name;
        },
        localSpecies(species) {
            if (!species || species === this.species) return;
            this.localName = species.name;
            this.$emit('updateSpecies', species);
            this.setDefaultSpecies(species);
        },
        speciesList(speciesList) {
            const species = speciesList.find(s => s.name === this.localName);
            if (species != null) this.localSpecies = species;
        },
    },
    computed: {
        ...mapState('species', ['speciesList', 'isLoading', 'defaultSpecies']),
    },
    created() {
        if (this.localSpecies) this.localName = this.localSpecies.name;
        else this.localSpecies = this.defaultSpecies;
        this.loadDefaultSpecies();
    },
    methods: {
        ...mapActions('species', ['loadDefaultSpecies', 'loadAllSpecies']),
        ...mapMutations('species', ['setDefaultSpecies']),
        onSpeciesComplete() {
            if (!this.localName) return;
            const species = this.speciesList.find(s => s.name === this.localName);
            if (species) this.localSpecies = species;
            else this.createSpecies(this.localName);
        },
        createSpecies(name) {
            this.loadAllSpecies();
            alert(`Virkelig? ${name}? Prøv igjen, eller send melding til support.`);
        },
    },
};
</script>

<style></style>
